/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    instanceOfSingleDetectorConnectorType,
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';

/**
 * @type EquipmentTypeCatalogDtoSingleDetectorConnectorType
 * 
 * @export
 */
export type EquipmentTypeCatalogDtoSingleDetectorConnectorType = SingleDetectorConnectorType;


export function EquipmentTypeCatalogDtoSingleDetectorConnectorTypeFromJSON(json: any): EquipmentTypeCatalogDtoSingleDetectorConnectorType {
    return EquipmentTypeCatalogDtoSingleDetectorConnectorTypeFromJSONTyped(json, false);
}

export function EquipmentTypeCatalogDtoSingleDetectorConnectorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentTypeCatalogDtoSingleDetectorConnectorType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...SingleDetectorConnectorTypeFromJSONTyped(json, true) };
    return  SingleDetectorConnectorTypeFromJSONTyped(json, true);
}

export function EquipmentTypeCatalogDtoSingleDetectorConnectorTypeToJSON(value?: EquipmentTypeCatalogDtoSingleDetectorConnectorType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfSingleDetectorConnectorType(value)) {
        return SingleDetectorConnectorTypeToJSON(value as SingleDetectorConnectorType);
    }

    return {};
}

/**
 * Check if a given object implements the EquipmentTypeCatalogDtoSingleDetectorConnectorType interface.
 */
export function instanceOfEquipmentTypeCatalogDtoSingleDetectorConnectorType(value: any): value is EquipmentTypeCatalogDtoSingleDetectorConnectorType {
    if (instanceOfSingleDetectorConnectorType(value)) return true;
    return false;
}

